<template>
  <el-dialog
    class="customize-columns__dialog"
    :width="width"
    title="自定义列表显示项"
    :visible.sync="customizeDialogVisible"
    :before-close="closeDialog">
    <p class="desc-text">请勾选下列选框，用于展示到{{tablename}}页面中！</p>
    <!-- 订单列表 -->
    <div v-if="tablename === '订单列表'">
      <div class="checkbox-content">
        <div class="checkbox-items">
          <el-checkbox v-model="order.id">订单号</el-checkbox>
          <el-checkbox v-model="order.customerName">客户</el-checkbox>
          <el-checkbox v-model="order.customerOrderNumber">客户订单号</el-checkbox>
          <el-checkbox v-model="order.fbaNumber">FBA号</el-checkbox>
          <el-checkbox v-model="order.warehousCode">仓库</el-checkbox>
          <el-checkbox v-model="order.batchIds">批次号</el-checkbox>
          <el-checkbox v-model="order.trackingNumbers">转单号</el-checkbox>
          <el-checkbox v-model="order.productName">产品</el-checkbox>
          <el-checkbox v-model="order.totalCarton">货物箱数</el-checkbox>
          <el-checkbox v-model="order.yuBaoWeight">客户预报重量(kg)</el-checkbox>
          <el-checkbox v-model="order.shiCeWeight">实测重量(kg)</el-checkbox>
          <el-checkbox v-model="order.zipcode">邮编</el-checkbox>
          <el-checkbox v-model="order.costAmountLocked">应付锁定</el-checkbox>
          <el-checkbox v-model="order.salesAmountLocked">应收锁定</el-checkbox>
        </div>
        <div class="checkbox-items">
          <el-checkbox v-model="order.chargingWeight">计费重 (kg/m³)</el-checkbox>
          <el-checkbox v-model="order.totalAmount">总运费</el-checkbox>
          <el-checkbox v-model="order.goodsTypeName">货物类型</el-checkbox>
          <el-checkbox v-model="order.generalTrade">一般贸易</el-checkbox>
          <el-checkbox v-model="order.createAt">下单时间</el-checkbox>
          <el-checkbox v-model="order.customerServiceStaff">客服</el-checkbox>
          <el-checkbox v-model="order.salesman">业务员</el-checkbox>
          <el-checkbox v-model="order.statusName">当前状态</el-checkbox>
          <el-checkbox v-model="order.nextStatusName">下一状态</el-checkbox>
          <el-checkbox v-model="order.detainGoods">扣货状态</el-checkbox>
          <el-checkbox v-model="order.audit">审核状态</el-checkbox>
          <el-checkbox v-model="order.company">分公司</el-checkbox>
        </div>
      </div>
    </div>

    <!-- 批次操作 -->
    <div v-if="tablename === '批次操作'">
      <div class="checkbox-content">
        <div class="checkbox-items">
          <el-checkbox v-model="batch.id">批次号</el-checkbox>
          <el-checkbox v-model="batch.airlines">航空公司</el-checkbox>
          <el-checkbox v-model="batch.shippingCompany">船公司</el-checkbox>
          <el-checkbox v-model="batch.railwayCompany">铁路公司</el-checkbox>
          <el-checkbox v-model="batch.airBill">航空单号</el-checkbox>
          <el-checkbox v-model="batch.guihao">柜号</el-checkbox>
          <el-checkbox v-model="batch.agencyCompany">代理公司</el-checkbox>
          <el-checkbox v-model="batch.totalOrder">订单总数</el-checkbox>
          <el-checkbox v-model="batch.qty">箱数</el-checkbox>
          <el-checkbox v-model="batch.weight">毛重(kg)</el-checkbox>
          <el-checkbox v-model="batch.volume">体积(cbm)</el-checkbox>
          <el-checkbox v-model="batch.tidanWeight">提单重</el-checkbox>
          <el-checkbox v-model="batch.costDone">批次费用完成</el-checkbox>
          <el-checkbox v-model="batch.purchaseInsurance">是否购买保险</el-checkbox>
        </div>
        <div class="checkbox-items">
          <el-checkbox v-model="batch.billingWeight">计费重</el-checkbox>
          <el-checkbox v-model="batch.chuhuo">出货</el-checkbox>
          <el-checkbox v-model="batch.timeInCustody">入监管仓时间</el-checkbox>
          <el-checkbox v-model="batch.declaration">报关完成时间</el-checkbox>
          <el-checkbox v-model="batch.clearance">清关完成时间</el-checkbox>
          <el-checkbox v-model="batch.departure">起飞时间</el-checkbox>
          <el-checkbox v-model="batch.driving">开车时间</el-checkbox>
          <el-checkbox v-model="batch.kaichuan">开船时间</el-checkbox>
          <el-checkbox v-model="batch.landing">落地时间</el-checkbox>
          <el-checkbox v-model="batch.port">到港时间</el-checkbox>
          <el-checkbox v-model="batch.arrival">到达时间</el-checkbox>
          <el-checkbox v-model="batch.songcang">送仓时间</el-checkbox>
          <el-checkbox v-model="batch.totalPickedUp">上网件数</el-checkbox>
          <el-checkbox v-model="batch.totalDelivered">签收件数</el-checkbox>
          <el-checkbox v-model="batch.pTime">上网时效</el-checkbox>
          <el-checkbox v-model="batch.STime">签收时效</el-checkbox>
        </div>
        <div class="checkbox-items">
          <el-checkbox v-model="batch.completion">分货完成时间</el-checkbox>
          <el-checkbox v-model="batch.inspection">是否查验</el-checkbox>
          <el-checkbox v-model="batch.noticeInspection">通知查验日期</el-checkbox>
          <el-checkbox v-model="batch.release">放行日期</el-checkbox>
          <el-checkbox v-model="batch.extractionTime">末端派送时间</el-checkbox>
          <el-checkbox v-model="batch.orderPrescription">时效</el-checkbox>
          <el-checkbox v-model="batch.remarks">备注</el-checkbox>
          <el-checkbox v-model="batch.inspectionFee">查验费收取(¥)</el-checkbox>
          <el-checkbox v-model="batch.inspectionBill">查验费单</el-checkbox>
          <el-checkbox v-model="batch.customsFeeList">费用凭证</el-checkbox>
          <el-checkbox v-model="batch.inspectionNotice">查验通知</el-checkbox>
          <el-checkbox v-model="batch.carriers">承运商</el-checkbox>
        </div>
      </div>
    </div>

    <!-- 提货订单 -->
    <div v-if="tablename === '提货订单'">
      <div class="checkbox-content">
        <div class="checkbox-items">
          <el-checkbox v-model="pickup.id">订单号</el-checkbox>
          <el-checkbox v-model="pickup.orgOwnerName">客户</el-checkbox>
          <el-checkbox v-model="pickup.warehousCode">仓库</el-checkbox>
          <el-checkbox v-model="pickup.productName">渠道</el-checkbox>
          <el-checkbox v-model="pickup.contractName">联系人</el-checkbox>
          <el-checkbox v-model="pickup.phone">联系方式</el-checkbox>
          <el-checkbox v-model="pickup.totalCarton">货物箱数</el-checkbox>
        </div>
        <div class="checkbox-items">
          <el-checkbox v-model="pickup.totalWeight">货物重量(kg)</el-checkbox>
          <el-checkbox v-model="pickup.totalVolume">货物体积(m3)</el-checkbox>
          <el-checkbox v-model="pickup.address">取件地址</el-checkbox>
          <el-checkbox v-model="pickup.vehicle">推荐车辆</el-checkbox>
          <el-checkbox v-model="pickup.driver">提货司机</el-checkbox>
          <el-checkbox v-model="pickup.date">下单时间</el-checkbox>
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog()">取 消</el-button>
      <el-button size="small" @click="confirmColumns()" type="primary">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "customizeColumns",
  props: {
    width: {
      type: String,
      default: "500px"
    },
    customizeDialogVisible: Boolean,
    customizeShowColumns: Object,
    isYiXunDa: {
      type: Boolean,
      default: false
    },
    tablename: String
  },
  data() {
    return {
      order: {
        id: true,
        customerName: true,
        customerOrderNumber: true,
        fbaNumber: false,
        warehousCode: false,
        batchIds: false,
        trackingNumbers: false,
        productName: true,
        totalCarton: true,
        yuBaoWeight: false,
        shiCeWeight: false,
        chargingWeight: true,
        totalAmount: true,
        goodsTypeName: true,
        generalTrade: true,
        createAt: true,
        customerServiceStaff: false,
        salesman: false,
        statusName: true,
        nextStatusName: true,
        detainGoods: false,
        audit: true,
        zipcode: false,
        costAmountLocked:false,
        company: false
      },
      batch: {
        id: true,
        airlines: true,
        shippingCompany: true,
        railwayCompany: true,
        airBill: true,
        guihao: true,
        agencyCompany: false,
        totalOrder: true,
        qty: true,
        weight: true,
        volume: false,
        tidanWeight: false,
        billingWeight: false,
        chuhuo: false,
        timeInCustody: false,
        declaration: false,
        clearance: false,
        departure: false,
        driving: false,
        landing: false,
        port: false,
        arrival: false,
        songcang: false,
        completion: false,
        inspection: false,
        noticeInspection: false,
        release: false,
        extractionTime: false,
        orderPrescription: false,
        remarks: false,
        inspectionFee: false,
        inspectionBill: false,
        customsFeeList: false,
        inspectionNotice: false,
        carriers: false,
        costDone:false,
        salesAmountLocked:false,
        totalPickedUp:true,
        totalDelivered:true,
        pTime:true,
        STime:true,
        purchaseInsurance: true
      },
      pickup: {
        id: true,
        orgOwnerName: true,
        warehousCode: true,
        productName: true,
        contractName: true,
        phone: false,
        totalCarton: false,
        totalWeight: false,
        totalVolume: false,
        address: true,
        vehicle: true,
        driver: true,
        date: true
      }
    };
  },
  created() {
    this.$nextTick(() => {
      this._initOrder();
    });
  },
  methods: {
    // 关闭弹层
    closeDialog() {
      this.$emit("closeCustomizeDialog", false);
    },
    // 勾选完成
    confirmColumns() {
      switch (this.tablename) {
        case "订单列表":
          localStorage.setItem(
            "customizeTmsOpOrderColumns",
            JSON.stringify(this.order)
          );
          this.$emit("selectedColumns", this.order);
          break;
        case "批次操作":
          localStorage.setItem(
            "customizeTmsOpBatchColumns",
            JSON.stringify(this.batch)
          );
          this.$emit("selectedColumns", this.batch);
          break;
        case "提货订单":
          localStorage.setItem(
            "customizeTmsOpPickUpColumns",
            JSON.stringify(this.pickup)
          );
          this.$emit("selectedColumns", this.pickup);
          break;
      }
    },
    _initOrder() {
      switch (this.tablename) {
        case "订单列表":
          if (localStorage.getItem("customizeTmsOpOrderColumns")) {
            let customizeTmsOpOrderColumns = JSON.parse(
              localStorage.getItem("customizeTmsOpOrderColumns")
            );
            this._initCustomizeTmsOpOrderColumns(customizeTmsOpOrderColumns);
          } else {
            this._initCustomizeTmsOpOrderColumns(this.customizeShowColumns);
          }
          break;
        case "批次操作":
          if (localStorage.getItem("customizeTmsOpBatchColumns")) {
            let customizeTmsOpBatchColumns = JSON.parse(
              localStorage.getItem("customizeTmsOpBatchColumns")
            );
            this._initCustomizeTmsOpBatchColumns(customizeTmsOpBatchColumns);
          } else {
            this._initCustomizeTmsOpBatchColumns(this.customizeShowColumns);
          }
          break;
        case "提货订单":
          if (localStorage.getItem("customizeTmsOpPickUpColumns")) {
            let customizeTmsOpPickUpColumns = JSON.parse(
              localStorage.getItem("customizeTmsOpPickUpColumns")
            );
            this._initCustomizeTmsOpPickUpColumns(customizeTmsOpPickUpColumns);
          } else {
            this._initCustomizeTmsOpPickUpColumns(this.customizeShowColumns);
          }
          break;
      }
    },
    // 给自定义列表项的对象赋值
    _initCustomizeTmsOpOrderColumns(val) {
      for (let key in val) {
        this.order[key] = val[key];
      }
    },
    _initCustomizeTmsOpBatchColumns(val) {
      for (var key in val) {
        this.batch[key] = val[key];
      }
    },
    _initCustomizeTmsOpPickUpColumns(val) {
      for (var key in val) {
        this.pickup[key] = val[key];
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/customize-columns.vue